<div class="fx-row fx-wrap align-items-start justify-content-start">
  <div class="fx-row align-items-stretch justify-content-left fx-flex-100 mb-16">
    <div class="w-100 fx-row fx-wrap pr-16" style="height:200px;">
      <app-upload-documents-box class="h-100 fx-flex-100"></app-upload-documents-box>
    </div>
    <div class="fx-flex-50 pl-16" style="height:200px;" *ngIf="!isOperator">
      <app-document-map [territories]="countries"></app-document-map>
    </div>
  </div>
  <div class="fx-flex-100" *ngIf="!loading && done && !noDocs">
    <mat-card class="fx-flex-100 mv-8">
      <div class="fx-row align-items-center justify-content-between fx-flex-100 mb-8">
        <span class="text dark bold">{{'HOME.RECENTLY_UPLOADED' | translate}}</span>
        <a href="/documents">{{'ACTIONS.VIEW_ALL' | translate}}</a>
      </div>
      <app-documents-table [filteredDocuments]="lastDocuments.docs" [pager]="lastDocuments" [paginable]="false"
        [sortable]="false" />
    </mat-card>
  </div>
</div>